export default function CountdownTimer(
  node,
  {
    endDate,
    countdownMessage = 'Order your gifts',
    fallbackMessage = 'Time is up!',
  } = {
    countdownMessage: 'Order your gifts',
    fallbackMessage: 'Time is up!',
  },
) {
  this.node = node ?? null

  // Convert endDate from PST to local time
  const pstDate = new Date(endDate) // Input date assumed to be in PST
  const pstOffset = 8 * 60 // PST offset in minutes (UTC-8)
  const utcTimestamp = pstDate.getTime() + pstOffset * 60 * 1000 // Convert PST to UTC
  const localTimestamp =
    utcTimestamp - new Date().getTimezoneOffset() * 60 * 1000 // Convert UTC to local time

  this.endDate = localTimestamp // Use the converted local time
  this.countdownMessage = countdownMessage
  this.fallbackMessage = fallbackMessage
  this.updateInterval = 1000
  this.initialMessage = 'Only'
  this.finalMessage = 'left!'
  this.timerInterval = null

  if (!this.node) {
    throw new Error('No countdown container detected')
  }

  const calculateTimeLeft = () => {
    const now = new Date().getTime()
    const distance = this.endDate - now

    if (distance < 0) {
      clearInterval(this.timerInterval)
      this.node.innerHTML = this.fallbackMessage
      return null
    } else {
      const days = Math.floor(distance / (1000 * 60 * 60 * 24))
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60),
      )
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60))
      const seconds = Math.floor((distance % (1000 * 60)) / 1000)
      return { days, hours, minutes, seconds }
    }
  }

  const updateTimer = () => {
    const timeLeft = calculateTimeLeft()

    if (timeLeft) {
      this.node.innerHTML = `
          ${this.countdownMessage} ${this.initialMessage} <strong>${timeLeft.days}</strong>d <strong>${timeLeft.hours}</strong>h <strong>${timeLeft.minutes}</strong>m <strong>${timeLeft.seconds}</strong>s ${this.finalMessage}
        `
    }
  }

  this.start = () => {
    updateTimer()
    this.timerInterval = setInterval(updateTimer, this.updateInterval)
  }

  this.stop = () => {
    clearInterval(this.timerInterval)
  }

  this.reset = (newEndDate) => {
    const pstDate = new Date(newEndDate)
    const utcTimestamp = pstDate.getTime() + pstOffset * 60 * 1000
    const localTimestamp =
      utcTimestamp - new Date().getTimezoneOffset() * 60 * 1000
    this.endDate = localTimestamp
    this.start()
  }

  // Initialize the countdown
  this.start()
}
